import { Skeleton, Table, Tbody, Td, Tr } from "@chakra-ui/react";

const TableSkeleton = ({ rows = 3, columns = 4 }) => {
  const rowsArray = Array.from({ length: rows });
  const columnsArray = Array.from({ length: columns });

  return (
    <Table variant="unstyled">
      <Tbody>
        {rowsArray.map((_, rowIndex) => (
          <Tr key={rowIndex}>
            {columnsArray.map((_, columnIndex) => (
              <Td key={columnIndex} pl={0}>
                <Skeleton height="20px" />
              </Td>
            ))}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default TableSkeleton;
